// BOM / ECO / Product structures exports that keep running after the Export window is closed.
//
// These exports run in the browser (walk the tree, then build the file or ask the server for the
// zip), so closing the window never stopped them — it only hid the progress. This store keeps
// each run visible: the window registers it, reports progress and the end, and the page-level
// chip (BackgroundExports, rendered once in App) shows it like the matrix's "Exporting N%".
// A full page reload does end the run (it lives in this tab), and the window says so.
import { useSyncExternalStore } from 'react';

let jobs = [];
let seq = 0;
const listeners = new Set();

function emit() {
  jobs = [...jobs];
  listeners.forEach((l) => l());
}

function patch(id, fields) {
  const j = jobs.find((x) => x.id === id);
  if (!j) return;
  Object.assign(j, fields);
  emit();
}

/** Start tracking one export; returns its handle. */
export function startExportJob(name) {
  const id = ++seq;
  jobs.push({ id, name, done: 0, total: 0, status: 'running', error: '' });
  emit();
  return {
    progress: (done, total) => patch(id, { done, total }),
    finish: () => {
      patch(id, { status: 'done' });
      setTimeout(() => dismissExportJob(id), 4000);
    },
    fail: (error) => patch(id, { status: 'error', error: error || 'Export failed.' }),
  };
}

export function dismissExportJob(id) {
  const before = jobs.length;
  jobs = jobs.filter((j) => j.id !== id);
  if (jobs.length !== before) emit();
}

function subscribe(l) {
  listeners.add(l);
  return () => listeners.delete(l);
}

export function useExportJobs() {
  return useSyncExternalStore(subscribe, () => jobs);
}
